// ══════════════════════════════════════════════════════════════
// COMPASS – Board Member Actions (US-041)
// ══════════════════════════════════════════════════════════════

import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ManagementCompanyBoardMemberDto } from '../../api/models/management-company-board-member-dto';
import { ManagementCompanyBoardMemberRequestDto } from '../../api/models/management-company-board-member-request-dto';

export const BoardMemberActions = createActionGroup({
  source: 'Board Member',
  events: {
    // All of a management company's Board Members (active and inactive)
    'Load Board Members': props<{ managementCompanyId: string }>(),
    'Load Board Members Success': props<{ boardMembers: ManagementCompanyBoardMemberDto[] }>(),
    'Load Board Members Failure': props<{ error: string }>(),

    // Create (no boardMemberId) or edit; the dialog that sends it shows the failure itself (field errors)
    'Save Board Member': props<{
      managementCompanyId: string; boardMemberId?: string; body: ManagementCompanyBoardMemberRequestDto;
    }>(),
    'Save Board Member Success': props<{ boardMember: ManagementCompanyBoardMemberDto; created: boolean }>(),
    'Save Board Member Failure': props<{ error: string; fieldErrors?: Record<string, string> }>(),

    'Deactivate Board Member': props<{ managementCompanyId: string; boardMemberId: string }>(),
    'Deactivate Board Member Success': props<{ boardMember: ManagementCompanyBoardMemberDto }>(),
    'Deactivate Board Member Failure': props<{ error: string; managementCompanyId: string }>(),

    'Reactivate Board Member': props<{ managementCompanyId: string; boardMemberId: string }>(),
    'Reactivate Board Member Success': props<{ boardMember: ManagementCompanyBoardMemberDto }>(),
    'Reactivate Board Member Failure': props<{ error: string; managementCompanyId: string }>(),

    'Clear Board Members': emptyProps(),
  },
});
